import { Action } from '../actions/action';
import { Command } from './command';

export class UndoCommand implements Command {
  public serializeToString(): string {
    return `undo`;
  }

  public execute(actionList: Action[]): boolean {
    if (actionList.length <= 0) {
      return false;
    }

    const lastAction = actionList[actionList.length - 1];
    lastAction.undo();

    actionList.pop();

    return true;
  }

  public static isCommand(command: Command): command is UndoCommand {
    return command instanceof UndoCommand;
  }
}
